// словарь весов символов
const weightDictionary = {
	'1': 10,
	'2': 15,
	'3': 15,
	'4': 16,
	'5': 15,
	'6': 16,
	'7': 15,
	'8': 15,
	'9': 16,
	'0': 17,
	'A': 19,
	'B': 17,
	'C': 18,
	'D': 19,
	'E': 16,
	'F': 16,
	'G': 19,
	'H': 18,
	'I': 8,
	'J': 13,
	'K': 18,
	'L': 15,
	'M': 21,
	'N': 19,
	'O': 20,
	'P': 16,
	'Q': 20,
	'R': 17,
	'S': 15,
	'T': 16,
	'U': 18,
	'V': 18,
	'W': 27,
	'X': 17,
	'Y': 17,
	'Z': 17,
	'А': 19,
	'Б': 17,
	'В': 17,
	'Г': 14,
	'Д': 18,
	'Е': 16,
	'Ё': 16,
	'Ж': 26,
	'З': 16,
	'И': 19,
	'Й': 19,
	'К': 18,
	'Л': 18,
	'М': 21,
	'Н': 18,
	'О': 20,
	'П': 18,
	'Р': 16,
	'С': 18,
	'Т': 16,
	'У': 18,
	'Ф': 22,
	'Х': 17,
	'Ц': 18,
	'Ч': 17,
	'Ш': 26,
	'Щ': 27,
	'Ъ': 19,
	'Ы': 22,
	'Ь': 16,
	'Э': 18,
	'Ю': 25,
	'Я': 17,
	'!': 7,
	'-': 10,
	'—': 22,
	'+': 15,
	'%': 20,
	'#': 17,
	'&': 17,
	'?': 13,
	'.': 6,
	',': 6,
	':': 7,
	';': 7,
	'«': 15,
	'»': 15,
	'(': 11,
	')': 11,
	'\\': 15,
	'/': 14,
	'|': 8,
	'@': 24,
	"'": 6,
	'"': 12,
	' ': 7
};

// считаем веса символов
export function calculateWeight(value = '') {
	const inputValue = value.trim();
	let sum = 0;

	for (let i = 0; i < inputValue.length; i++) {
		const char = inputValue[i].toUpperCase();

		if (char in weightDictionary) {
			sum += weightDictionary[char];
		}
	}

	return sum;
}

export const titleValidation = (title) => {
	let titleErrorText = (title === null || title.length === 0) ? 'это поле нужно заполнить' : null
	if (!titleErrorText) {
		const sum = calculateWeight(title);
		if (sum > 1190) {
			titleErrorText = 'Превышен вес заголовка'
		}
	}
	return titleErrorText;
}



// WEBPACK FOOTER //
// src/util/validation.js